/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: LAgK4hEGm2TV
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import TopNav from "../../TopNav"; // plasmic-import: MzgISFkf8fEm/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicSectionHero.module.css"; // plasmic-import: LAgK4hEGm2TV/css

createPlasmicElementProxy;

export const PlasmicSectionHero__VariantProps = new Array("colWidth");

export const PlasmicSectionHero__ArgProps = new Array(
  "sectionId",
  "showTagline",
  "navbar",
  "children",
  "slot"
);

const $$ = {};

function PlasmicSectionHero__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          showTagline: true
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "colWidth",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.colWidth
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <section
      data-plasmic-name={"hero"}
      data-plasmic-override={overrides.hero}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.hero
      )}
      id={(() => {
        try {
          return $props.sectionId;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <TopNav
            className={classNames("__wab_instance", sty.topNav___3Jhqe)}
          />
        ),

        value: args.navbar
      })}
      <div
        data-plasmic-name={"contentHero"}
        data-plasmic-override={overrides.contentHero}
        className={classNames(projectcss.all, sty.contentHero, {
          [sty.contentHerocolWidth_full]: hasVariant($state, "colWidth", "full")
        })}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox__fJy5, {
            [sty.freeBoxcolWidth_full__fJy5LltAt]: hasVariant(
              $state,
              "colWidth",
              "full"
            ),
            [sty.freeBoxcolWidth_medium__fJy5DmGby]: hasVariant(
              $state,
              "colWidth",
              "medium"
            ),
            [sty.freeBoxcolWidth_small__fJy5KyDar]: hasVariant(
              $state,
              "colWidth",
              "small"
            )
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox__lqO6, {
              [sty.freeBoxcolWidth_full__lqO6LltAt]: hasVariant(
                $state,
                "colWidth",
                "full"
              ),
              [sty.freeBoxcolWidth_medium__lqO6DmGby]: hasVariant(
                $state,
                "colWidth",
                "medium"
              ),
              [sty.freeBoxcolWidth_small__lqO6KyDar]: hasVariant(
                $state,
                "colWidth",
                "small"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: (
                <h1
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    projectcss.__wab_text,
                    sty.h1__raVXf
                  )}
                >
                  {"Enter some text"}
                </h1>
              ),

              value: args.children
            })}
          </div>
          {(() => {
            try {
              return $props.showTagline;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return true;
              }
              throw e;
            }
          })() ? (
            <div
              className={classNames(projectcss.all, sty.freeBox__pjkTl, {
                [sty.freeBoxcolWidth_full__pjkTLlltAt]: hasVariant(
                  $state,
                  "colWidth",
                  "full"
                ),
                [sty.freeBoxcolWidth_medium__pjkTldmGby]: hasVariant(
                  $state,
                  "colWidth",
                  "medium"
                ),
                [sty.freeBoxcolWidth_small__pjkTLkyDar]: hasVariant(
                  $state,
                  "colWidth",
                  "small"
                )
              })}
            >
              {renderPlasmicSlot({
                defaultContents: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__xx4Mg
                    )}
                  >
                    {"Enter some text"}
                  </div>
                ),

                value: args.slot
              })}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}

const PlasmicDescendants = {
  hero: ["hero", "contentHero"],
  contentHero: ["contentHero"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSectionHero__ArgProps,
          internalVariantPropNames: PlasmicSectionHero__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSectionHero__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "hero") {
    func.displayName = "PlasmicSectionHero";
  } else {
    func.displayName = `PlasmicSectionHero.${nodeName}`;
  }
  return func;
}

export const PlasmicSectionHero = Object.assign(
  // Top-level PlasmicSectionHero renders the root element
  makeNodeComponent("hero"),
  {
    // Helper components rendering sub-elements
    contentHero: makeNodeComponent("contentHero"),
    // Metadata about props expected for PlasmicSectionHero
    internalVariantProps: PlasmicSectionHero__VariantProps,
    internalArgProps: PlasmicSectionHero__ArgProps
  }
);

export default PlasmicSectionHero;
/* prettier-ignore-end */
